import React from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { defaultSchema } from 'hast-util-sanitize';
import remarkGfm from 'remark-gfm';

import tags, { bubbleTags } from './Tags';

const Container = styled.div`
  ${tw`w-full`}
`;

const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [
    ...defaultSchema.tagNames,
    // Support underlines that githubs schema does not.
    'u'
  ],
  attributes: {
    ...defaultSchema.attributes,
    // Support inline `style` tags for every element.
    '*': [...defaultSchema.attributes['*'], 'style']
  }
};

const Markdown = ({ isBubble = false, children, ...props }) => (
  <Container>
    <ReactMarkdown
      rehypePlugins={[
        // Support HTML.
        rehypeRaw,
        // Sanitize any HTML using schema.
        [rehypeSanitize, sanitizeSchema]
      ]}
      remarkPlugins={[
        // Support tables.
        remarkGfm
      ]}
      components={isBubble ? bubbleTags : tags}
      {...props}
    >
      {children}
    </ReactMarkdown>
  </Container>
);

Markdown.propTypes = {
  isBubble: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Markdown;
export { tags, sanitizeSchema };